import * as React from 'react'
import type { SVGProps } from 'react'
const SvgPinterest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7417 22.5092A11 11 0 0 0 12 23c6.0754 0 11-4.9246 11-11S18.0754 1 12 1 1 5.9246 1 12a11.005 11.005 0 0 0 6.9904 10.2464c-.097-.871-.1828-2.2079.0383-3.159.1997-.8575 1.2896-5.4673 1.2896-5.4673s-.3295-.6589-.3295-1.6336c0-1.5288.8868-2.6716 1.9913-2.6716.9387 0 1.3911.7051 1.3911 1.5501 0 .6025-.2448 1.3956-.5021 2.2294-.1466.4738-.2967.9601-.4084 1.4328-.2595 1.0955.5495 1.9879 1.6291 1.9879 1.9552 0 3.458-2.0613 3.458-5.0375 0-2.6332-1.8931-4.4756-4.5952-4.4756-3.1296 0-4.9675 2.3479-4.9675 4.7746 0 .9455.3644 1.9597.8191 2.5103.0903.1094.1027.2042.0756.3159l-.194.7942-.1106.4536c-.0485.2008-.1602.2437-.3678.1466-1.3742-.6397-2.2339-2.6479-2.2339-4.2612 0-3.4704 2.5216-6.6575 7.2691-6.6575 3.8167 0 6.7816 2.719 6.7816 6.3529 0 3.7919-2.3907 6.8425-5.7087 6.8425-1.1147 0-2.1628-.5787-2.5204-1.2635 0 0-.5528 2.1018-.686 2.6163-.2482.9544-.9183 2.1526-1.3674 2.8825"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgPinterest
